import React, { Component } from 'react';
import { connect } from 'react-redux';

class Settings extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className="dash-wrapper d-flex align-items-center justify-content-center">
        <h1>Settings page!</h1>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  {}
)(Settings);



// WEBPACK FOOTER //
// ./src/views/settings/index.js